import { handleActions } from "redux-actions";

import {
    CHANGE_RETAILER_PROFILE_DATA,
    RETAILER_BRAND_NAMES_SUGGESTIONS,
    RETAILER_PROFILE_SET_INITIAL,
} from "constants/action-types";

import { RetailerProfile } from "../records/retailer-profile";

interface IState {
    location: any;
    brandInfo?: { _id: string; name: string };
    profileData: RetailerProfile | null;
    brandNameSuggestions: string[];
}

const initialState: IState = {
    location: {},
    brandInfo: null,
    profileData: new RetailerProfile(),
    brandNameSuggestions: [],
};

export const retailerProfileForm = handleActions(
    {
        [CHANGE_RETAILER_PROFILE_DATA]: (state: IState, { payload }): IState => {
            return {
                ...state,
                profileData: payload.profileData,
            };
        },
        [RETAILER_BRAND_NAMES_SUGGESTIONS]: (state: IState, { payload }): IState => {
            return {
                ...state,
                brandNameSuggestions: payload as any,
            };
        },
        [RETAILER_PROFILE_SET_INITIAL]: (state: IState, { payload }): IState => {
            return {
                ...state,
                ...payload,
            };
        },
    },
    initialState,
);
